import { toast } from "sonner";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { useDeleteLead } from "@/hooks/useLeads";

type Props = {
  leadId: string;
  leadName: string | null;
  open: boolean;
  onClose: () => void;
};

export function DeleteLeadDialog({
  leadId,
  leadName,
  open,
  onClose,
}: Props): React.JSX.Element {
  const deleteLead = useDeleteLead();
  const displayName = leadName ?? "este lead";

  function handleConfirm(): void {
    deleteLead.mutate(leadId, {
      onSuccess: () => {
        toast.success("Lead eliminado");
        onClose();
      },
      onError: (err) => {
        toast.error(err.message ?? "Error al eliminar el lead");
      },
    });
  }

  return (
    <AlertDialog open={open} onOpenChange={(v: boolean) => !v && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Eliminar a {displayName}?</AlertDialogTitle>
          <AlertDialogDescription>
            Esta acción no se puede deshacer desde el tablero. Puedes
            restaurarlo desde la vista de leads.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleteLead.isPending}>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={deleteLead.isPending}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {deleteLead.isPending ? "Eliminando…" : "Eliminar"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
